import { useCallback, useState } from 'react';

export interface DealsMoreFiltersDrawerController {
  isOpen: boolean;
  openMoreFiltersDrawer: () => void;
  closeMoreFiltersDrawer: () => void;
}

interface UseDealsMoreFiltersDrawerOptions {
  onClose?: () => void;
}

export const useDealsMoreFiltersDrawer = ({
  onClose,
}: UseDealsMoreFiltersDrawerOptions = {}): DealsMoreFiltersDrawerController => {
  const [isOpen, setIsOpen] = useState(false);

  const openMoreFiltersDrawer = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeMoreFiltersDrawer = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose]);

  return {
    isOpen,
    openMoreFiltersDrawer,
    closeMoreFiltersDrawer,
  };
};
